import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import {   Row,
    Col,
    Card,
    CardBody,
    Dropdown,
    UncontrolledTooltip, 
    Table,
    Container } from "reactstrap";
import { Link } from 'react-router-dom';
import { useMemo } from "react";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { APPNAME } from 'helpers/url_helper';
import avatar1 from "../../assets/images/users/avatar-1.jpg"

//import images
import vacancy from "../../assets/images/companies/Screenshot_2.png";
import logo from "../../assets/images/logo-dark.png";

import Select from 'react-select';
import countryList from 'react-select-country-list'
import axios from 'axios';
import * as url from "../../helpers/url_helper"
import {HRConfig, HRConfig2, formatDate } from 'helpers/backend_helper';
import { useHistory, useParams } from 'react-router-dom';

    const CreateApplication = () => {
        const {id} = useParams()
        const [recrProjNo, setRecrProjNo] = useState("")
        const [positionCode, setPositionCode] = useState("")
        const [jobTitle, setJobTitle] = useState("")
        const [quantityRequested, setQuantityRequested] = useState("")
        const [applicationSubmissionDeadline, setApplicationSubmissionDeadline] = useState("")
        const history = useHistory();
        const [projects, setProjects] = useState([])
        const [firstName, setFirstName] = useState('')
        const [lastName, setLastName] = useState('')
        const [middleName, setMiddleName] = useState('')
        const [gender, setGender] = useState('')
        const [email, setEmail] = useState('')
        const [phone, setPhone] = useState('')
        const [country, setCountry] = useState('')
        const [dateofbirth, setDateofBirth] = useState('')
        const [username, setusername] = useState('')
        const [countryResidence, setCountryResidence] = useState('')
        const [address, setAddress] = useState('')
        const [hearaboutus, setHearAboutUs] = useState('')
        const [maritalstatus, setMaritalStatus] = useState('')
        const [nationalID, setNationalID] = useState('')
        const [passport, setPassport] = useState('')
        const [recruitmentProjectNo, setRecruitmentProjectNo] = useState('')
        const [positionTitle, setPositionTitle] = useState('')
        const [closeDate, setCloseDate] = useState('')

        const [applicantNo, setApplicantNo] = useState('')
        const [applicantID, setApplicantID] = useState('')
        const options = useMemo(() => countryList().getData(), [])
        const [workExperienceLines, setWorkExperienceLines] = useState([])
        const [vacancies, setvacancies] = useState(0)
        const [applications, setapplications] = useState(0)
        const [isLoading, setIsLoading] = useState(false)

        const [positionDescription, setPositionDescription] = useState([])
        const [positionEducation, setPositionEducation] = useState([])
        const [positionCertificates, setPositionCertificates] = useState([])
        const [positionSkills, setPositionSkills] = useState([])
        const [vacanciesAvailable, setVacanciesAvailable] = useState('')

        const changeHandler = countryResidence => {
            setCountryResidence(countryResidence)
        }   

        const handleSubmit = () =>{
            if(countryResidence == ""){
              toastr.error("Enter your country/region of residence");
            }else if(address.trim() == ""){
              toastr.error('Enter a valid address')
            }else if(hearaboutus == ""){
                toastr.error("Please tell us how you found out about this vaccancy"); 
            }else if(maritalstatus == ""){
              toastr.error('Enter your marital status')
            }else{
              const data = {
                FirstName: firstName,
                MiddleName: middleName,
                LastName: lastName,
                Sex: gender,
                DateOfBirth: formatDate(dateofbirth),
                CountryofOrigin: country.label,
                EMail: email,
                MobilePhoneNo: phone,
                CountryofResidence: countryResidence.label,
                Address2: address,
                HeardAboutus: hearaboutus,
                MaritalStatus: maritalstatus,
                NationalIDNumber: nationalID,
                PassportNo: passport,  
                RecruitmentProjectNo: recrProjNo,
                PositionCode: positionCode,
                PositionTitle: jobTitle,
                CloseDate: formatDate(applicationSubmissionDeadline),
                QuantityRequested: quantityRequested
              }
              setIsLoading(true)
              axios.post(url.APPLICANTS, JSON.stringify(data), HRConfig2).then((r)=>{
                  toastr.success('Application saved successfully. Proceed to next section')
                  console.log(r)
                  console.log(r.data.SystemId)
                  setApplicantID(r.data.SystemId)
                  console.log(r.data.applicantID)
                  history.push(`/create-application-details/${r.data.SystemId}`)
                  fetchProjects()
                  setFirstName('')
                  setLastName('')
                  setEmail('')
                  setPhone('')
              }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
              })
            }
          }
        
        const fetchProjects = () =>{
            setIsLoading(true)
            axios.get(`${url.RECRUITMENTPROJECTSX}(${id})?$expand=positionDescription,positionEducation,positionCertificates,positionSkills`, HRConfig).then((r)=>{
                
                setRecrProjNo(r.data.RecrProjNo)
                setPositionCode(r.data.PositionCode)
                setJobTitle(r.data.jobTitle)
                setQuantityRequested(r.data.QuantityRequested)
                setCloseDate(r.data.closeDate)
                setApplicationSubmissionDeadline(r.data.applicationSubmissionDeadline)
                setPositionDescription(r.data.positionDescription)
                setPositionEducation(r.data.positionEducation)
                setPositionCertificates(r.data.positionCertificates)
                setPositionSkills(r.data.positionSkills)
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
            axios.get(`${url.APPLICANTS}(${id})?$expand=applicantWorkExperience,applicantEducation,applicantCertifications`, HRConfig)
            .then((r)=>{
                console.log(r)
                setRecrProjNo(r.data.RecrProjNo)  
                setApplicantNo(r.data.ApplicantNo)
                setPositionCode(r.data.PositionCode)
                setRecruitmentProjectNo(r.data.RecruitmentProjectNo)
                setPositionTitle(r.data.PositionTitle)
                setPositionCode(r.data.PositionCode)
                setQuantityRequested(r.data.QuantityRequested)
                setJobTitle(r.data.jobTitle)
                setQuantityRequested(r.data.QuantityRequested)
                setApplicationSubmissionDeadline(r.data.applicationSubmissionDeadline)
                setPositionDescription(r.data.positionDescription)
                setPositionEducation(r.data.positionEducation)
                setPositionCertificates(r.data.positionCertificates)
                setPositionSkills(r.data.positionSkills)
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
        }
        useEffect(() => {
            if (localStorage.getItem("authApplicant")) {
                const obj = JSON.parse(localStorage.getItem("authApplicant"))
                setusername(`${obj.fname} ${obj.lname}`)
                setFirstName(`${obj.fname}`)
                setLastName(`${obj.lname}`)
                setMiddleName(`${obj.mname}`)
                setGender(`${obj.gender}`)
                setPhone(`${obj.phone}`)
                setEmail(`${obj.email}`)
                setDateofBirth(`${obj.dateofbirth}`)
                setCountry(`${obj.country}`)
                fetchProjects()
            }
          }, [])

          //MMO New Details page
          return (
            <div className="page-content">
            <MetaTags>
            <title>Vacancy details | {APPNAME}</title>
            </MetaTags>
            <Container fluid={true}>
                <Breadcrumbs title={APPNAME} breadcrumbItem="Vacancy details" />
                <Row>
                    <Col lg="12">
                    <Card>
                        <CardBody>
                        <Row>
                            <Col lg="5">
                            <div className="d-flex">
                                <div className="me-3">
                                <img
                                    src={avatar1}
                                    alt=""
                                    className="avatar-md rounded-circle img-thumbnail"
                                />
                                </div>
                                <div className="flex-grow-1 align-self-center">
                                <div className="text-muted">
                                    <p className="mb-2">Welcome to MILDMAY Job applications portal</p>
                                    <h5 className="mb-1">{username}</h5>
                                    <p className="mb-0">Applicant</p>
                                </div>
                                </div>
                            </div>
                            </Col>

                            <Col lg="7" className="align-self-center">
                            <div className="text-lg-center mt-4 mt-lg-0">
                                <Row>
                                <Col xs="6">
                                    <div>
                                    <p className="text-muted text-truncate mb-2">
                                        Vacancies
                                    </p>
                                    <h5 className="mb-0">3</h5>
                                    </div>
                                </Col>
                                <Col xs="6">
                                    <div>
                                    <p className="text-muted text-truncate mb-2">
                                        Applications
                                    </p>
                                    <h5 className="mb-0">0</h5>
                                    </div>
                                </Col>
                                
                                </Row>
                            </div>
                            </Col>

                            
                        </Row>
                        </CardBody>
                    </Card>
                    </Col>
                </Row>
                
            <React.Fragment>
            <Row>
                <Col xl={3}>
                    <Card>
                        <CardBody className="border-bottom">
                        <h5 className="fw-semibold">Overview</h5>
                            <div className="table-responsive">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <th scope="col">Project No</th>
                                        <td scope="col"> {recrProjNo} </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Position Code</th>
                                        <td scope="col">{positionCode}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Position Title</th>
                                        <td scope="col">{jobTitle}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Vacancy</th>
                                        <td>{quantityRequested}</td>
                                    </tr>
                                    {/* <tr>
                                        <th scope="row">Job Type</th>
                                        <td><span className="badge badge-soft-success">Full Time</span></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Posted Date</th>
                                        <td>25 June, 2022</td>
                                    </tr> */}
                                    <tr>
                                        <th scope="row">Close Date</th>
                                        <td>{applicationSubmissionDeadline}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                            <div className="hstack gap-2">
                            <Dropdown tag="a" href="https://www.MILDMAY.com/contact-us/" target="_blank" className="btn btn-primary btn-block w-100" ><i className="mdi mdi-phone-classic"/>{"  "}Contact Us</Dropdown>
                        </div>
                        </CardBody>
                    </Card>
                    <Card>
                    <CardBody>
                        <div className="text-center">
                            <img src={logo} alt="" height="50" className="mx-auto d-block" />
                            <h5 className="mt-3 mb-1">Uganda Electricity Generation Company Ltd.</h5>
                            <p className="text-muted mb-0">Since 2001</p>
                        </div>

                        <ul className="list-unstyled mt-4">
                            <li>
                                <div className="d-flex">
                                    <i className="bx bx-phone text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Phone</h6>
                                        <p className="text-muted fs-14 mb-0">+256 312 372165</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="bx bx-mail-send text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Email</h6>
                                        <p className="text-muted fs-14 mb-0">info@MILDMAY.go.ug</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="bx bx-globe text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Website</h6>
                                        <p className="text-muted fs-14 text-break mb-0">www.MILDMAY.com</p>
                                    </div>
                                </div>
                            </li>
                            <li className="mt-3">
                                <div className="d-flex">
                                    <i className="bx bx-map text-primary fs-4"></i>
                                    <div className="ms-3">
                                        <h6 className="fs-14 mb-2">Location</h6>
                                        <p className="text-muted fs-14 mb-0">Block C Plot 6-9 Okot Close Bukoto Victoria Office</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="hstack gap-2">
                            <Dropdown tag="a" href="https://www.google.com/maps/place/Uganda+Electricity+Generation+Company+Limited/@0.344662,32.593772,15z/data=!4m6!3m5!1s0x177dbbb20980436b:0xfc1d7682397704fa!8m2!3d0.3446615!4d32.5937724!16s%2Fg%2F11dymg3mfm?hl=en&entry=ttu" target="_blank" className="btn btn-primary btn-block w-100" ><i className="mdi mdi-google-maps"/>{" "}View Map</Dropdown>
                        </div>
                    </CardBody>
                </Card>
                </Col>

                
                <Col xl={9}>
                    <Card>
                        <CardBody className="border-bottom">
                            <div className="d-flex">
                                <img src={vacancy} alt="" height="50" />
                                <div className="flex-grow-1 ms-5">
                                    <h5 className="fw-semibold">REGISTERED INFORMATION</h5>
                                    <ul className="list-unstyled hstack gap-2 mb-0">
                                        <li>
                                            <i className="bx bx-building-house"></i> <span className="text-muted">MILDMAY</span>
                                        </li>
                                        <li>
                                            <i className="bx bx-map"></i> <span className="text-muted">Uganda</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <Row>
                            <Col xl = {4}>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-rename text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">First Name</h6>
                                                <p className="text-muted fs-14 mb-0">{firstName}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-rename text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Last Name</h6>
                                                <p className="text-muted fs-14 mb-0">{lastName}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-rename text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Other Names</h6>
                                                <p className="text-muted fs-14 mb-0">{middleName}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            <Col xl = {4}>
                            <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-calendar text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Date of Birth</h6>
                                                <p className="text-muted fs-14 mb-0">{dateofbirth}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-globe-alt text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Country/Region of Origin</h6>
                                                <p className="text-muted fs-14 mb-0">{country}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-user text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Gender</h6>
                                                <p className="text-muted fs-14 mb-0">{gender}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            <Col xl = {4}>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-phone text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Phone</h6>
                                                <p className="text-muted fs-14 mb-0">{phone}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-mail-send text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Email</h6>
                                                <p className="text-muted fs-14 mb-0">{email}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            </Row>
                            
                        </CardBody>
                        <CardBody className="border-bottom">
                            <div className="d-flex">
                                <img src={vacancy} alt="" height="50" />
                                <div className="flex-grow-1 ms-5">
                                    <h5 className="fw-semibold">PERSONAL INFORMATION</h5>
                                    <ul className="list-unstyled hstack gap-2 mb-0">
                                        <li>
                                            <i className="bx bx-building-house"></i> <span className="text-muted">MILDMAY</span>
                                        </li>
                                        <li>
                                            <i className="bx bx-map"></i> <span className="text-muted">Uganda</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <Row>
                            <Col xl = {6}>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-globe text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Country of Residence</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                    <Select options={options} 
                                                        value={countryResidence} 
                                                        onChange={changeHandler}
                                                        placeholder="Select your current country or region of residence.">
                                                    </Select>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-home-alt text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Physical Address</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <input 
                                                    className="form-control" 
                                                    type="text" 
                                                    value={address} 
                                                    onChange={(e)=>setAddress(e.target.value)}
                                                />
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-question-mark text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">How did you hear about us</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <select className="form-select" 
                                                    value={hearaboutus} 
                                                    onChange={(e)=>setHearAboutUs(e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option value="Social Media">Social Media</option>
                                                    <option value="GlassDoor">GlassDoor</option>
                                                    <option value="LinkedIn">LinkedIn</option>
                                                    <option value="Newspaper or Magazine">Newspaper or Magazine</option>
                                                    <option value="MILDMAY Outreach/Career Fair">MILDMAY Outreach/Career Fair</option>
                                                    <option value="Referral from a friend/Colleague">Referral from a friend/Colleague</option>
                                                    <option value="Search Engine">Search Engine</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            <Col xl = {6}>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="mdi mdi-human-male-female text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Marital Status</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <select className="form-select" 
                                                    value={maritalstatus} 
                                                    onChange={(e)=>setMaritalStatus(e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option value="Single">Single</option>
                                                    <option value="Married">Married</option>
                                                    <option value="Divorced">Divorced</option>
                                                    <option value="Separated">Separated</option>
                                                    <option value="Widow">Widow</option>
                                                    <option value="Widower">Widower</option>
                                                </select>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="mdi mdi-id-card text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">National ID (Ugandan Citizens only)</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <input 
                                                    className="form-control" 
                                                    type="text" 
                                                    value={nationalID} 
                                                    onChange={(e)=>setNationalID(e.target.value)}
                                                />
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul className="list-unstyled mt-4">
                                    <li>
                                        <div className="d-flex">
                                            <i className="bx bx-book text-primary fs-4"></i>
                                            <div className="ms-3">
                                                <h6 className="fs-14 mb-2">Passport Number (Non-Ugandan applicants)</h6>
                                                <p className="text-muted fs-14 mb-0">
                                                <input 
                                                    className="form-control" 
                                                    type="text" 
                                                    value={passport} 
                                                    onChange={(e)=>setPassport(e.target.value)}
                                                />
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </Col>
                            <div className="hstack gap-2">
                                <button className="btn btn-success btn-block w-100" onClick={handleSubmit}><i className="mdi mdi-content-save"/>{" "}Save and Continue</button>
                        </div>
                            </Row>
                        </CardBody>

                    </Card>
                        </Col>
                </Row>
            </React.Fragment>
            
            </Container>
            </div>
        );
    }

export default CreateApplication;